export default __webpack_public_path__ + "static/media/dh25Banner2.13c3cde0.png";